/**
 * Formats a calling code.
 *
 * @param callingCode The calling code.
 * @returns The formatted calling code.
 */
export function formatCallingCode(callingCode: string) {
  if (!callingCode) {
    return ''
  }

  return callingCode.startsWith('+') ? callingCode : `+${callingCode}`
}

/**
 * Formats a phone number with a country code.
 *
 * @param countryPhoneCode The country phone code.
 * @param phoneNumber The phone number.
 * @param phoneNumberIncludesCountryPhoneCode Whether the phone number includes the country phone code.
 * @returns The formatted phone number.
 */
export async function formatPhoneNumber({
  countryPhoneCode,
  phoneNumber,
  phoneNumberIncludesCountryPhoneCode = false,
  displayCallingCode = true,
}: {
  countryPhoneCode?: string
  phoneNumber: string
  phoneNumberIncludesCountryPhoneCode?: boolean
  displayCallingCode?: boolean
}) {
  const parsedNumber = await parsePhoneNumber({
    countryPhoneCode,
    phoneNumber,
    phoneNumberIncludesCountryPhoneCode,
  })

  if (parsedNumber) {
    if (!displayCallingCode) {
      return parsedNumber.formatNational()
    }

    return `${formatCallingCode(parsedNumber.countryCallingCode)} ${parsedNumber.formatNational()}`
  }

  return ''
}
